import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from  "vuex-persist"

import MiscelaneousModule from "./miscelaneous";
import CandidateModule from "./candidateCurp";
import AuthModule from "./auth";
import ApplicantModule from "./applicant";
import PaymentModule from "./payment";
import ApplicantionsModule from "./applications"
import ClubsModule from "./clubs"
import UsersModule from "./users"
import DocumentationModule from "./documentation"
import AdminModule from "./admin";
import ConfigurationModule from "./configuration";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    key: 'vuexP',
    storage: window.localStorage,
    reducer: (state) => ({ auth: state.auth, payment: state.payment, applicant: state.applicant, admin: state.admin})
})

export default new Vuex.Store({
    strict: true, 
    modules: {
        miscelaneous: MiscelaneousModule,
        candidate: CandidateModule,
        auth: AuthModule,
        applicant: ApplicantModule,
        payment: PaymentModule,
        applications: ApplicantionsModule,
        clubs: ClubsModule,
        users: UsersModule,
        documentation: DocumentationModule,
        admin: AdminModule,
        ...ConfigurationModule
    },
    plugins: [vuexLocal.plugin]
})